import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useNavigate } from "react-router-dom";
import messages from "./messages.i18n";
import { PeekGrid, PeekPaper, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useDebounce, usePolicies, useUsers } from "@piiqtechnologies/ui-lib";
import SearchText from "@components/common/search-text";
import TabsLayout from "@layouts/tabs";
import { PATHS } from "@constants/Paths";
import AppHeader from "@components/app-header";
import CreateUser from "@components/users/users-table/users-table-actions/CreateUser";
var USERS_TAB;
(function (USERS_TAB) {
    USERS_TAB["USERS_USERS"] = "users";
    USERS_TAB["USERS_USER_REQUESTS"] = "user-request";
})(USERS_TAB || (USERS_TAB = {}));
export const UsersLayout = () => {
    const intl = useIntl();
    const theme = useTheme();
    const [noOfUsers, setNoOfUsers] = useState(0);
    const [noOfUsersRequests, setNoOfUsersRequests] = useState(0);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(USERS_TAB.USERS_USERS);
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [getUsers, usersResponse] = useUsers();
    const [getUserRequests, userRequestsResponse] = usePolicies();
    useEffect(() => {
        getUsers({});
        getUserRequests({ resource: "communities", requestedAccess: true });
    }, []);
    const updateNoOfUsers = (count) => {
        setNoOfUsers(count);
    };
    const updateNoOfUserRequests = (count) => {
        setNoOfUsersRequests(count);
    };
    useEffect(() => {
        setNoOfUsers(usersResponse === null || usersResponse === void 0 ? void 0 : usersResponse.totalCount);
    }, [usersResponse]);
    useEffect(() => {
        setNoOfUsersRequests(userRequestsResponse === null || userRequestsResponse === void 0 ? void 0 : userRequestsResponse.totalCount);
    }, [userRequestsResponse]);
    const handleTabChange = (value) => {
        navigate(value);
    };
    useEffect(() => {
        const usersURLSegments = location.pathname.split("/");
        const activeTabURL = usersURLSegments.pop() || usersURLSegments.pop();
        const isValidTabValue = USERS_TABS.map(({ value }) => value).includes(activeTabURL);
        setTabValue((isValidTabValue && activeTabURL) || PATHS.USERS_USERS);
    }, [location.pathname]);
    const USERS_TABS = useMemo(() => [
        {
            value: PATHS.USERS_USERS,
            label: messages.usersUsersTitle,
            labelBadgeContent: { count: `${noOfUsers || 0}` },
        },
        {
            value: PATHS.USERS_USER_REQUESTS,
            label: messages.usersUserRequestsTitle,
            labelBadgeContent: { count: `${noOfUsersRequests || 0}` },
        },
    ], [noOfUsers, noOfUsersRequests]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center", height: theme.spacing(4) },
                React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.usersTitle) }),
                tabValue === USERS_TAB.USERS_USERS && (React.createElement(SearchText, { placeholder: intl.formatMessage(messages.usersSearch), searchText: searchKey, onChange: setSearchKey })))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekPaper, { sx: { p: 1.5 } },
                React.createElement(RefetchProvider, null,
                    React.createElement(TabsLayout, { tabs: USERS_TABS, activeTab: tabValue, onTabChange: handleTabChange, TabAction: React.createElement(CreateUser, null), TabContent: React.createElement(Outlet, { context: {
                                searchKey: debouncedSearchKey,
                                updateNoOfUsers,
                                updateNoOfUserRequests,
                            } }) }))))));
};
